import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onCreateGraduatedWorkInfo,
  onDeleteGraduatedWorkInfo,
  onGetGraduatedWorkInfo,
  onUpdateGraduatedWorkInfo,
  onGetGraduatedWorkInfoByGraduatedId,
} from '../../../app/modules/graduation-system/components/graduates/component/geaduated-work-info/core/_requests'
import {
  onGetGraduates,
  onGetCardStatuses,
  onGetDeliveryTypes,
  onGetJobTypes,
  onGetInstitutionTypes,
} from '../../../app/services/dataForComboBox/dataForComboBoxService'
interface GraduatedWorkInfoState {
  graduatedWorkInfos: any
  graduatedWorkInfo: any
  graduates: any
  institutionTypes: any
  jobTypes: any
  isLoading: boolean
}
const initialState = {
  graduatedWorkInfos: [],
  graduatedWorkInfo: null,
  graduates: [],
  institutionTypes: [],
  jobTypes: [],
  isLoading: true,
} as GraduatedWorkInfoState

export const fetchGraduates = createAsyncThunk('graduatedWorkInfo/fetchGraduates', async () => {
  const data: any = await onGetGraduates()
  return data.data.result
})

export const fetchJobTypes = createAsyncThunk('graduatedWorkInfo/fetchJobTypes', async () => {
  const data: any = await onGetJobTypes()
  return data.data.result
})

export const fetchInstitutionTypes = createAsyncThunk(
  'graduatedWorkInfo/fetchInstitutionTypes',
  async () => {
    const data: any = await onGetInstitutionTypes()
    return data.data.result
  }
)

export const fetchGraduatedWorkInfosByGraduatedId = createAsyncThunk(
  'graduatedWorkInfo/fetchGraduatedWorkInfosByGraduatedId',
  async (param: any) => {
    const data: any = await onGetGraduatedWorkInfoByGraduatedId(param)
    return data.data.result
  }
)

export const fetchGraduatedWorkInfo = createAsyncThunk(
  'graduatedWorkInfo/fetchGraduatedWorkInfo',
  async (param: any) => {
    const data: any = await onGetGraduatedWorkInfo(param)
    return data.data.result
  }
)

export const updateGraduatedWorkInfo = createAsyncThunk(
  'graduatedWorkInfo/updateGraduatedWorkInfo',
  async (param: any) => {
    const data: any = await onUpdateGraduatedWorkInfo(param)
    return data.data
  }
)

export const createGraduatedWorkInfo = createAsyncThunk(
  'graduatedWorkInfo/createGraduatedWorkInfo',
  async (param: any) => {
    const data: any = await onCreateGraduatedWorkInfo(param)
    return data.data
  }
)

export const deleteGraduatedWorkInfo = createAsyncThunk(
  'graduatedWorkInfo/deleteGraduatedWorkInfo',
  async (param: any) => {
    const data: any = await onDeleteGraduatedWorkInfo(param)
    return data.data
  }
)

const graduatedWorkInfoSlice = createSlice({
  name: 'graduatedWorkInfo',
  initialState,
  reducers: {
    clearGraduatedWorkInfos: (state) => {
      state.graduatedWorkInfos = []
    },
    clearGraduatedWorkInfo: (state) => {
      state.graduatedWorkInfo = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchGraduatedWorkInfosByGraduatedId.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchGraduatedWorkInfosByGraduatedId.fulfilled, (state: any, action) => {
      state.graduatedWorkInfos = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchGraduatedWorkInfosByGraduatedId.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchGraduatedWorkInfo.fulfilled, (state: any, action) => {
      state.graduatedWorkInfo = action.payload
    })
    builder.addCase(fetchGraduates.fulfilled, (state: any, action) => {
      state.graduates = action.payload.items
    })
    builder.addCase(fetchJobTypes.fulfilled, (state: any, action) => {
      state.jobTypes = action.payload.items
    })
    builder.addCase(fetchInstitutionTypes.fulfilled, (state: any, action) => {
      state.institutionTypes = action.payload.items
    })
  },
})

export const {clearGraduatedWorkInfos, clearGraduatedWorkInfo, activateLoading} =
  graduatedWorkInfoSlice.actions

export default graduatedWorkInfoSlice.reducer
